import { __decorate } from "tslib";
import { omit } from "lodash-es";
import { wujiRequest } from "../core/common/wujiRequest";
import getCustomHeaders from "../tools/getCustomHeaders";
import getManagePathPrefix from "../tools/getManagePathPrefix";
import Vue from 'vue';
/**
 * collection接口
 */
export class CollectionService {
  constructor() {
    this.events = new Vue();
  }
  /**
   * 获取projectId下所有collection
   * @param projectId
   * @returns
   */
  async getAllCollection(projectId, filter = '') {
    const res = await wujiRequest({
      method: 'get',
      url: `${getManagePathPrefix()}/datasource/basic/collection`,
      params: {
        projectid: projectId,
        size: 'total',
        filter,
        sort: '_mtime',
        order: 'desc'
      }
    });
    return res;
  }
  /**
   * 创建collection
   * @param data
   * @returns
   */
  async create(data) {
    const res = await wujiRequest({
      url: `${getManagePathPrefix()}/datasource/collection?projectid=${data.projectId}`,
      method: 'post',
      data
    });
    return res;
  }
  /**
   * 获取单个collection
   * @param collectionId
   * @param projectId
   * @returns
   */
  async find(collectionId, projectId, includes = []) {
    const res = await wujiRequest({
      url: `${getManagePathPrefix()}/datasource/collection/${collectionId}?projectid=${projectId}${(includes === null || includes === void 0 ? void 0 : includes.length) > 0 ? `&include=${includes.join(',')}` : ''}`,
      method: 'get'
    });
    return res && omit(res, ['afterHooks']);
  }
  getRuntimeHeaders(simplifyCgiSchema) {
    const headers = getCustomHeaders() || {};
    if (simplifyCgiSchema) {
      headers['xy-simplify-cgi-schema'] = 'simplify';
    }
    return headers;
  }
  async findRuntimeConfig(options) {
    const {
      collectionId,
      projectId,
      pageId,
      envId,
      simplifyCgiSchema
    } = options;
    const res = await wujiRequest({
      url: `${getManagePathPrefix({
        envId
      })}/datasource/collection/${collectionId}?projectid=${projectId}&pageid=${pageId}`,
      method: 'get',
      headers: this.getRuntimeHeaders(simplifyCgiSchema)
    });
    return res;
  }
  async findRuntimeConfigList(options) {
    const {
      collectionIds,
      projectId,
      pageId,
      envId,
      simplifyCgiSchema
    } = options;
    if (collectionIds.length <= 0) return [];
    const filter = collectionIds.map(id => `collectionId="${id}"`).join('|');
    const res = await wujiRequest({
      url: `${getManagePathPrefix({
        envId
      })}/datasource/collection/?filter=${encodeURIComponent(`${filter}`)}&projectid=${projectId}&pageid=${pageId}`,
      headers: this.getRuntimeHeaders(simplifyCgiSchema)
    });
    return res;
  }
  /**
   * 更新collection
   * @param data
   * @returns
   */
  async update(data) {
    const res = await wujiRequest({
      url: `${getManagePathPrefix()}/datasource/collection/patch/${data.collectionId}?projectid=${data.projectId}`,
      method: 'post',
      data
    });
    return res;
  }
  /**
   * 删除collection
   * @param data
   * @returns
   */
  async delete(collectionId, projectId) {
    const res = await wujiRequest({
      url: `${getManagePathPrefix()}/datasource/collection/delete/${collectionId}?projectid=${projectId}`,
      method: 'post'
    });
    return res;
  }
  /**
   * 复制collection
   * @param projectId 项目ID
   * @param data.originCollectionId 原始collectionId
   * @param data.collectionId 新的collectionId
   * @param data.name 新的collectionName
   */
  async copy(projectId, data) {
    const res = await wujiRequest({
      url: `${getManagePathPrefix()}/datasource/collection/copy?projectid=${projectId}`,
      method: 'post',
      data
    });
    return res;
  }
  /**
   * 根据页面ID查询页面下所有数据源ID
   */
  async findIdByPageId(projectId, pageId) {
    const res = await wujiRequest({
      url: `${getManagePathPrefix()}/datasource/page/collection/${pageId}?projectid=${projectId}`
    });
    return res;
  }
}
__decorate([emit('create')], CollectionService.prototype, "create", null);
__decorate([emit('update')], CollectionService.prototype, "update", null);
__decorate([emit('delete')], CollectionService.prototype, "delete", null);
__decorate([emit('copy')], CollectionService.prototype, "copy", null);
export const collectionService = new CollectionService();
export function emit(eventName) {
  return function (_target, _key, desc) {
    const method = desc.value;
    if (typeof method !== 'function') return desc;
    // @ts-ignore
    desc.value = async function (...args) {
      let res;
      try {
        res = await method.apply(this, args);
        return res;
      } catch (error) {
        throw error;
      } finally {
        this.events.$emit(eventName, res);
      }
    };
    return desc;
  };
}
//# sourceMappingURL=collectionService.js.map
